// Configuración de EmailJS para BelkysVeterinaria
export const EMAIL_CONFIG = {
  // Estos valores se obtienen de las variables de entorno o valores por defecto
  SERVICE_ID: process.env.REACT_APP_EMAILJS_SERVICE_ID || 'service_jtmbef2',
  TEMPLATE_ID: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'template_vfd7jhg', 
  PUBLIC_KEY: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'JuXtYzg1pXmw4mRWV',
  
  // Información de la clínica
  CLINIC_NAME: process.env.REACT_APP_CLINIC_NAME || 'BelkysVeterinaria',
  CLINIC_PHONE: process.env.REACT_APP_CLINIC_PHONE || '+57 321 610 3829',
  CLINIC_EMAIL: process.env.REACT_APP_CLINIC_EMAIL || 'belkysveterinaria@gmail.com',
};

// Template de email en HTML
export const EMAIL_TEMPLATE = {
  subject: '{{#if_reminder}}🔔 RECORDATORIO{{else}}✅ CONFIRMACIÓN{{/if_reminder}} - {{paciente_name}} - BelkysVeterinaria',
  html: `
    <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; background: #ffffff;">
      <!-- Header -->
      <div style="background: #602442; color: white; padding: 20px; text-align: center;">
        <h1 style="margin: 0; font-size: 28px;">🐾 BelkysVeterinaria</h1>
        <p style="margin: 5px 0 0 0; font-size: 16px;">{{email_type}}</p>
      </div>
      
      <!-- Contenido Principal -->
      <div style="padding: 30px; background: #f9f9f9;">
        <h2 style="color: #602442; margin-top: 0;">Estimado/a {{owner_name}},</h2>
        
        <p style="font-size: 16px; line-height: 1.6;">
          {{intro_message}}
        </p>
        </p>
        
        <!-- Detalles de la Cita -->
        <div style="background: white; padding: 20px; border-left: 4px solid #c46494; margin: 20px 0; border-radius: 5px;">
          <h3 style="color: #602442; margin-top: 0; font-size: 18px;">📋 Detalles de la Cita:</h3>
          <p style="margin: 10px 0; font-size: 16px;"><strong>📅 Fecha:</strong> {{appointment_date}}</p>
          <p style="margin: 10px 0; font-size: 16px;"><strong>🕐 Hora:</strong> {{appointment_time}}</p>
          <p style="margin: 10px 0; font-size: 16px;"><strong>🩺 Tipo de Consulta:</strong> {{appointment_type}}</p>
          {{#if motivo}}
          <p style="margin: 10px 0; font-size: 16px;"><strong>📝 Motivo:</strong> {{motivo}}</p>
          {{/if}}
        </div>
        
        <!-- Recordatorios -->
        <div style="background: #fcdcf4; padding: 15px; border-radius: 5px; margin: 20px 0;">
          <h4 style="color: #602442; margin-top: 0;">⚠️ Recordatorios Importantes:</h4>
          <ul style="margin: 10px 0; padding-left: 20px;">
            <li>Llegue 10 minutos antes de la cita programada</li>
            <li>Traiga el historial médico previo de su mascota</li>
            <li>Si necesita cancelar, hágalo con 24 horas de anticipación</li>
            <li>Mantenga a su mascota en ayuno si es consulta médica</li>
          </ul>
        </div>
        
        <!-- Contacto -->
        <div style="text-align: center; margin: 30px 0; padding: 20px; background: white; border-radius: 5px;">
          <h4 style="color: #a55e88; margin-top: 0;">Para reprogramar o cancelar su cita:</h4>
          <p style="margin: 10px 0;">
            📱 <strong>WhatsApp:</strong> 
            <a href="https://wa.me/573216103829?text=Hola, necesito reprogramar la cita de {{paciente_name}}" 
               style="color: #25D366; text-decoration: none; font-weight: bold;">
              +57 321 610 3829
            </a>
          </p>
          <p style="margin: 10px 0;">
            📧 <strong>Email:</strong> 
            <a href="mailto:belkysveterinaria@gmail.com?subject=Reprogramar cita - {{paciente_name}}" 
               style="color: #602442; text-decoration: none; font-weight: bold;">
              belkysveterinaria@gmail.com
            </a>
          </p>
        </div>
      </div>
      
      <!-- Footer -->
      <div style="background: #602442; color: white; padding: 20px; text-align: center;">
        <p style="margin: 0; font-size: 14px;">
          © 2025 BelkysVeterinaria - Cuidando a tu mascota con amor profesional
        </p>
        <p style="margin: 5px 0 0 0; font-size: 12px; opacity: 0.8;">
          Este es un recordatorio automático. Por favor no responder a este email.
        </p>
      </div>
    </div>
  `
};
